<template>
    <div class="ContactUs">
        <menuBox :step="4"></menuBox>
        <div class="title-box">Contact Us</div>

        <div class="img-box">
            <div class="flex-img">
                <img src="../assets/contact-1.png" alt="">
                <img src="../assets/contact-2.png" alt="">
            </div>
            <div class="img-text">
                <div>Get in Touch with Us</div>
                <p>We look forward to connecting with you, sharing our expertise and experience, and providing tailored solutions for your business. Whether you have inquiries about our services, partnership opportunities, or any other questions, we are eager to listen and assist you. Please feel free to reach out to us through the contact information provided at the bottom of the website.</p>
            </div>

        </div>

        <div class="fqs-box">
            <div class="title-left">
                <div class="title">Frequently Asked Questions (FAQs)</div>
                <img src="../assets/home_2.png" class="sbtitle">
            </div>
            <div class="fqs-list">
                <div class="fqs-item">
                    <div class="fqa" @click="fqs_1 = !fqs_1">
                        How can I contact your customer service team?
                        <img src="../assets/icon-2.png" alt="">
                    </div>
                    <p v-if="fqs_1">You can reach our customer service team via email, phone, or online chat. Our team will promptly respond to your inquiries and provide the assistance and support you need.</p>
                </div>
                <div class="fqs-item">
                    <div class="fqa" @click="fqs_2 = !fqs_2">
                        What payment methods do you accept for your services?
                        <img src="../assets/icon-2.png" alt="">
                    </div>
                    <p v-if="fqs_2">We accept various payment methods, including credit cards, PayPal, and bank transfers. You can choose the payment method that best suits your needs.</p>
                </div>
                <div class="fqs-item">
                    <div class="fqa" @click="fqs_3 = !fqs_3">
                        What is the scope of your services?
                        <img src="../assets/icon-2.png" alt="">
                    </div>
                    <p v-if="fqs_3">Our services cover a wide range of areas, including SEO optimization, content marketing, social media management, and more. Whether you're a personal website, a small to medium-sized enterprise, or a large corporation, we can provide customized solutions to meet your needs.</p>
                </div>
            </div>
        </div>
        <footerBox :step="4"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            fqs_1: false,
            fqs_2: false,
            fqs_3: false,
            fqs_4: false,
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    font-weight: 600;
    font-size: 58px;
    color: #333333;
}

.sbtitle {
    width: 305px;
    margin: auto;
    margin-top: 20px;
}

.title-box {
    height: 512px;
    background-image: url(../assets/title-box.png);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 75px;
    color: #040F1C;
    display: flex;
    align-items: center;
    justify-content: center;
}

.img-box {
    padding: 120px 460px;

    .flex-img {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        img {
            width: 550px;
        }
    }

    .img-text {
        margin-top: 40px;

        div {
            font-weight: bold;
            font-size: 52px;
            color: #333333;
        }

        p {
            font-weight: 400;
            font-size: 20px;
            color: #333333;
            margin-top: 40px;
        }
    }
}

.fqs-box {
    padding: 160px 460px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-left {
        width: 600px;

        .title-1 {
            font-weight: 400;
            font-size: 20px;
            color: rgba(51, 51, 51, 0.8);
        }
    }

    .fqs-list {
        width: 550px;

        .fqs-item {
            padding: 30px 0px;
            border-top: 1px solid #E2E2E2;
            border-bottom: 1px solid #E2E2E2;

            .fqa {
                font-weight: 500;
                font-size: 20px;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: space-between;

                img {
                    width: 20px;
                    height: 20px;
                }
            }

            p {
                font-weight: 400;
                font-size: 16px;
                color: #999999;
                margin-top: 16px;
            }
        }
    }

}
</style>
